<div class="dialog-cover" [@slideContent]="animationState">
    <ng-container [ngTemplateOutlet]="currentTemplate">
    </ng-container>
</div>